import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { concatMap, map, type Observable } from 'rxjs';
import { type BaseService } from '@essent/common';
import { API_PUBLIC_PREFIX } from '@core/config-angular';

import type {
  EplusPresignedUrlResponse,
  EplusUploadFileRequestPayload,
  EplusUploadFileResponse,
} from './eplus-upload-file.interface';

@Injectable()
export class EplusUploadFileService
  implements BaseService<EplusUploadFileRequestPayload, EplusUploadFileResponse>
{
  readonly #httpClient = inject(HttpClient);
  readonly #apiUrl = inject(API_PUBLIC_PREFIX);
  public readonly apiVersion = '1';
  public endpoint = `${this.#apiUrl || ''}/feh/docs/presign/v${this.apiVersion}`;

  public call$(
    payload: EplusUploadFileRequestPayload
  ): Observable<EplusUploadFileResponse> {
    return this.#httpClient
      .get<EplusPresignedUrlResponse>(this.endpoint, {
        headers: {
          accept: 'application/json',
          brand: 'essent',
        },
      })
      .pipe(
        map((response) => {
          const file = payload.file;
          const formData = new FormData();

          Object.entries(response.presigned_post.fields).forEach(
            ([name, value]) => {
              formData.append(name, value);
            }
          );
          formData.append('Content-Type', file.type);
          formData.append('file', file, file.name);

          return {
            response,
            formData,
          };
        }),
        concatMap(({ response, formData }) =>
          this.#httpClient
            .post(response.presigned_post.url, formData)
            .pipe(
              map((_) => ({ documentKey: response.presigned_post.fields.key }))
            )
        )
      );
  }
}
